import { quotationList,quotationHistoryList } from "constants/quotation";

const initialState = {
  quotationList: {},
  quotationHistoryList: {}
};

const quotation = (state = initialState, action) => {
  switch (action.type) {
    case quotationList:
      return { ...state, quotationList: action.payload };
    case quotationHistoryList:
      return { ...state, quotationHistoryList: action.payload };
    default:
      return state;
  }
};

export default quotation;
